class eventConfig {
  static UNAUTHORIZED = 'UNAUTHORIZED_EVENT';
  
  static SOCKET_CHANGE = 'socketChange';

  static LANGUAGE_CHANGE = 'languageChange';

 }
module.exports = eventConfig;